<template>
  <hr class="asc-divider theme--light" />
</template>

<script>
export default {
  name: 'AscDivider',
}
</script>

<style lang="scss">
.asc-divider {
  display: block;
  max-width: 100%;
  height: 0;
  max-height: 0;
  flex: 1 1 0;
  border-style: solid;
  border-color: initial;
  border-image: initial;
  border-width: thin 0 0;
  transition: inherit;

  &.theme--light {
    border-color: $gray-300;
  }
}
</style>
